export default "__VITE_ASSET__Wi94Vibf__"